import React, { useState, useEffect, useRef } from 'react';
import * as RecordRTC from 'recordrtc';
import { Icons } from "../../assest/icons";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { logger } from '../../utils/logger';
import { ToastContainer, toast } from "react-toastify"; 
import { createMedicalReport, getUser, upsertPCPPharmacyDetails } from '../../services/firestore';
import { saveFHIRFromMedicalReport, saveFHIRPractitioner } from '../../services/fhirService';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../../firebase.config';

import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { fetchWithAppCheck, getAppCheckHeaders } from '../../utils/fetchWithAppCheck';

const PageTwo = () => {
  let navigate = useNavigate();
  const routeChange = () => {
    // Keep pageTwoData so user can see it if they come back before chatbot completes
    // appointmentStep stays as 'pagetwo' so they land here on return
    let path = `/chatbot`;
    navigate(path);
  } 

  const fileInputRef = useRef(null);
  const fileInputRefMedications = useRef(null);
  const fileInputRefMediConditions = useRef(null);
  const fileInputRefPSHistory = useRef(null);
  const fileInputRefPhysicalExam = useRef(null);
  const fileInputRefSocialHistory = useRef(null);
  const fileInputRefReport1 = useRef(null);
  const fileInputRefReport2 = useRef(null);
  const fileInputRefReport3 = useRef(null);
  const fileInputRefReport4 = useRef(null);
  const fileInputRefReport5 = useRef(null);

  const textareaRefAllergies = useRef(null);
  const textareaRefMedications = useRef(null);
  const textareaRefMediConditions = useRef(null);
  const textareaRefPSHistory = useRef(null);
  const textareaRefPhysicalExam = useRef(null);
  const textareaRefSocialHistory = useRef(null);
  const textareaRefPCP = useRef(null);
  const textareaRefPharmacy = useRef(null);

  
  const inputRefeMedicalConditionTxt = useRef(null);
  const inputRefePShistorytxt = useRef(null);
  const inputRefeMedicationstxt = useRef(null);
  const inputRefeAllergiestxt = useRef(null);
  
  const [PCPData, setPCPData] = useState('');
  const [PharmacyData, setPharmacyData] = useState('');


  const [uploadFiles, setUploadFiles] = useState([]);

  const [apiCallCount, setApiCallCount] = useState(0);
  const [apiSuccessCount, setApiSuccessCount] = useState(0);

  const [userIdVal, setUserId] = useState([]);
  const [ShowBMICal, setShowBMICal] = useState('');
  const [ShowLoader, setShowLoader] = useState(false);
  const [TxtLoader, setTxtLoader] = useState(false);

  const [selectedSmoking, setSelectedSmoking] = useState('');
  const [selectedAlcohol, setSelectedAlcohol] = useState('');
  const [selectedExercise, setSelectedExercise] = useState('');

  const [AllergiesData, setAllergiesData] = useState('');
  const [AllergiesFile, setAllergiesFile] = useState(null);
  const [fileNameAllergies, setFileNameAllergies] = useState('');

  const [MedicationsData, setMedicationsData] = useState('');
  const [MedicationsFile, setMedicationsFile] = useState(null);
  const [fileNameMedications, setFileNameMedications] = useState('');

  // Medication rows: [{ name: '', dose: '', frequency: '', searchText: '', suggestions: [], doseOptions: [] }, ...]
  const savedMedRows = JSON.parse(localStorage.getItem('pageTwoData') || 'null')?.medicationRows;
  const [medicationRows, setMedicationRows] = useState(
    savedMedRows && savedMedRows.length > 0
      ? savedMedRows.map(r => ({ ...r, suggestions: [], doseOptions: [] }))
      : [{ name: '', dose: '', frequency: '', searchText: '', suggestions: [], doseOptions: [] }]
  );

  const [SocialHistoryData, setSocialHistoryData] = useState('');
  const [SocialHistoryFile, setSocialHistoryFile] = useState(null);
  const [fileNameSocialHistory, setFileNameSocialHistory] = useState('');

  const [PhysicalExamData, setPhysicalExamData] = useState('');
  const [PhysicalExamFile, setPhysicalExamFile] = useState(null);
  const [fileNamePhysicalExam, setFileNamePhysicalExam] = useState('');

  const [MedicalConditionsData, setMedicalConditionsData] = useState('');
  const [MedicalConditionFile, setMedicalConditionFile] = useState(null);
  const [fileNameMedicalCondition, setFileNameMedicalCondition] = useState('');

  const [PastSurgicalHistoryData, setPastSurgicalHistoryData] = useState('');
  const [PSHistoryFile, setPSHistoryFile] = useState(null);
  const [fileNamePSHistory, setFileNamePSHistory] = useState('');

  const [UploadReport, setUploadReport] = useState('');

  const [BPMin, setBPMin] = useState('');
  const [BPHigh, setBPHigh] = useState('');
  const [HeartRate, setHeartRate] = useState('');
  const [bodyTemperature, setTemperature] = useState('');


  const [errors, setErrors] = useState({});
  const [isValid, setIsValid] = useState(false);

  const [activeSpeech, setActiveSpeech] = useState(null);
  const savedPageTwo = JSON.parse(localStorage.getItem('pageTwoData') || 'null');
  const [transcripts, setTranscripts] = useState(savedPageTwo?.transcripts || { allergies: '', medications: '', medicalcondition: '', pshistory: '', physicalexam : '', socialhistory: '', pcp: '', pharmacy:'', pcpName:'', pcpAddress:'', pcpPhone:'', pcpFax:'', pharmacyName:'', pharmacyAddress:'', pharmacyPhone:'', pharmacyFax:'' });
  const { transcript, resetTranscript, listening, browserSupportsSpeechRecognition } = useSpeechRecognition();
  const socket = useRef(null);
  const recorder = useRef(null);
  const streamRef = useRef(null);
  const [isRecording, setIsRecording] = useState({allergies: false, medications: false, medicalcondition: false, pshistory: false, physicalexam : false, socialhistory: false });
  const [activeMic, setActiveMic] = useState(null); 
  const [isConnecting, setIsConnecting] = useState(false);
  const [reportId, setReportId] = useState(() => {
    return JSON.parse(localStorage.getItem('reportId') || '""') || '';
  });

  const [suggestions, setSuggestions] = useState([]);
  const suggestionListRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allergiesSuggestions, setAllergiesSuggestions] = useState([]);
  const [medicationsSuggestions, setMedicationsSuggestions] = useState([]);
  const [pastSurgicalSuggestions, setPastSurgicalSuggestions] = useState([]);
  const [medicalConditionSuggestions, setMedicalConditionSuggestions] = useState([]);

  const [socialHistorySuggestions, setSocialHistorySuggestions] = useState([]);
  const [pcpSuggestions, setPCPSuggestions] = useState([]);
  const [pharmacySuggestions, setPharmacySuggestions] = useState([]);


  const [drugNames, setDrugNames] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  // API-only autosuggest mode (no local fallback list).
  const ENABLE_REMOTE_AUTOSUGGEST = true;
  // Use remote API by default to avoid localhost-relative calls.
  const AUTOSUGGEST_BASE_URL = (process.env.REACT_APP_AUTOSUGGEST_BASE_URL || 'https://us-central1-aigicare-prod.cloudfunctions.net').replace(/\/+$/, '');
  const AUTOSUGGEST_PATH = process.env.REACT_APP_AUTOSUGGEST_PATH || '/autoSuggest';

  const generateUniqueId = (id) => {
    const timestamp = new Date().getTime();
    setReportId(`report_${timestamp}_${id}`);
    localStorage.setItem('reportId', JSON.stringify(`report_${timestamp}_${id}`));
  };

  // Firebase autoSuggest — type: 'medicine' (allergies/medications) | 'social' (social history)
  const fetchSuggestions = async (input, setSuggestions, type = 'medicine') => {
    setIsLoading(true);
    try {
      const appCheckHeaders = await getAppCheckHeaders();
      const response = await axios.get(`${AUTOSUGGEST_BASE_URL}${AUTOSUGGEST_PATH}?query=${encodeURIComponent(input)}&type=${type}`, { headers: appCheckHeaders });
      const remoteSuggestions = response?.data?.suggestions || response?.data?.data || response?.data?.results || [];
      setSuggestions(Array.isArray(remoteSuggestions) ? remoteSuggestions : []);
      if (suggestionListRef.current) suggestionListRef.current.scrollTop = 0;
    } catch (error) {
      setSuggestions([]);
    } finally {
      setIsLoading(false);
    }
  };

  // For allergy suggestions — uses NLM drug name API (same NDC medicine database as old backend)
  const fetchSuggestionsAllergy = async (input, setSuggestions) => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search?terms=${encodeURIComponent(input)}&ef=STRENGTHS_AND_FORMS`
      );
      // Response format: [total, codes, extra, names]
      const drugNames = response.data[1] || [];
      setSuggestions(drugNames.slice(0, 15));
      if (suggestionListRef.current) suggestionListRef.current.scrollTop = 0;
    } catch (error) {
      // Fallback to Firebase autoSuggest
      try {
        const appCheckHeaders = await getAppCheckHeaders();
        const fallback = await axios.get(`${AUTOSUGGEST_BASE_URL}${AUTOSUGGEST_PATH}?query=${encodeURIComponent(input)}`, { headers: appCheckHeaders });
        setSuggestions(fallback?.data?.suggestions || []);
      } catch { setSuggestions([]); }
    } finally {
      setIsLoading(false);
    }
  };

  
  const fetchSuggestionsMedicalCondition = async (input, setSuggestions) => {
    setIsLoading(true);
    try {
      const response = await axios.get(  `https://clinicaltables.nlm.nih.gov/api/conditions/v1/search?terms=${encodeURIComponent(input)}&df=term_icd9_text,primary_name&autocomp=1`);
    
    const suggestionsArray = response.data[3]?.map((item) => item[1]) || [];
    setSuggestions(suggestionsArray); // Update suggestions state

    // Scroll the suggestion list to the top
    if (suggestionListRef.current) {
      suggestionListRef.current.scrollTop = 0;
    }
    } catch (error) { 
      setSuggestions([]);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchSuggestionsPastSurgical  = async (input, setSuggestions) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`https://clinicaltables.nlm.nih.gov/api/procedures/v3/search?terms=${encodeURIComponent(input)}`);
    
    const suggestionsArray = response.data[3]?.map((item) => item[0]) || [];
    setSuggestions(suggestionsArray); // Update suggestions state

    // Scroll the suggestion list to the top
    if (suggestionListRef.current) {
      suggestionListRef.current.scrollTop = 0;
    }
    } catch (error) { 
      setSuggestions([]);
    } finally {
      setIsLoading(false);
    }
  };
 
  // For medication suggestions — uses NLM RxTerms API (direct search, no full download)
  // Stores strengths/forms alongside drug names for dose selection
  const [medicationStrengthsMap, setMedicationStrengthsMap] = useState({});
  const fetchSuggestionsdrugName = async (input, setSuggestions) => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search?terms=${encodeURIComponent(input)}&ef=STRENGTHS_AND_FORMS`
      );
      // Response: [total, drug_names_array, { STRENGTHS_AND_FORMS: [[...], ...] }, display]
      const names = response.data[1] || [];
      const strengthsData = response.data[2]?.STRENGTHS_AND_FORMS || [];
      // Build map: drugName -> [dose options]
      const strengthsMap = {};
      names.forEach((name, idx) => {
        strengthsMap[name] = strengthsData[idx] || [];
      });
      setMedicationStrengthsMap(prev => ({ ...prev, ...strengthsMap }));
      setSuggestions(names.slice(0, 15));
      if (suggestionListRef.current) suggestionListRef.current.scrollTop = 0;
    } catch (error) {
      setSuggestions([]);
    } finally {
      setIsLoading(false);
    }
  };
 
  // Fetch phone & fax from NPPES NPI Registry via Cloud Function proxy
  const fetchNPPESDetails = async (placeName, formattedAddress) => {
    try {
      // Parse city and state from Google Places formatted address
      // Typical format: "123 Main St, City, ST 12345, USA"
      const addressParts = formattedAddress.split(',').map(p => p.trim());
      let city = '';
      let state = '';
      for (let i = addressParts.length - 1; i >= 0; i--) {
        const part = addressParts[i];
        // Match state + zip pattern like "DC 20003" or just state "DC"
        const stateMatch = part.match(/^([A-Z]{2})(?:\s+\d{5})?$/);
        if (stateMatch) {
          state = stateMatch[1];
          if (i > 0) city = addressParts[i - 1];
          break;
        }
      }

      const params = new URLSearchParams({ name: placeName });
      if (city) params.append('city', city);
      if (state) params.append('state', state);

      const response = await fetchWithAppCheck(
        `${AUTOSUGGEST_BASE_URL}/nppesLookup?${params.toString()}`
      );
      const data = await response.json();

      return {
        phone: data?.phone || '',
        fax: data?.fax || '',
      };
    } catch (error) {
      return { phone: '', fax: '' };
    }
  };

  // Normalize NPI result into the same shape the JSX already expects
  const normalizeNPIResult = (r) => {
    const addr = r.practiceAddress || {};
    const formattedAddress = [addr.address1, addr.city, addr.state, addr.postalCode]
      .filter(Boolean).join(', ');
    return {
      displayName: { text: r.fullName || '' },
      formattedAddress,
      _npi: r, // keep raw NPI data for phone/fax on selection
    };
  };

  // Search individual providers (PCP) via NPI Registry
  // Single word → first_name (matches GI portal behaviour: npiSearch?first_name=swaraj&limit=10)
  // Two+ words  → first_name=first word, last_name=rest
  const fetchNPISuggestionsProvider = async (input, setSuggestions) => {
    setIsLoading(true);
    try {
      const words = input.trim().split(/\s+/);
      const params = new URLSearchParams({ limit: '10' });
      if (words.length >= 2) {
        params.append('first_name', words[0]);
        params.append('last_name', words.slice(1).join(' '));
      } else {
        params.append('first_name', words[0]);
      }
      const res = await fetchWithAppCheck(`${AUTOSUGGEST_BASE_URL}/npiSearch?${params.toString()}`);
      const data = await res.json();
      setSuggestions((data.results || []).map(normalizeNPIResult));
      if (suggestionListRef.current) suggestionListRef.current.scrollTop = 0;
    } catch (error) {
      setSuggestions([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Search organizations (Pharmacy) via NPI Registry
  const fetchNPISuggestionsOrg = async (input, setSuggestions) => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams({ organization_name: input.trim(), limit: '10' });
      const res = await fetchWithAppCheck(`${AUTOSUGGEST_BASE_URL}/npiSearch?${params.toString()}`);
      const data = await res.json();
      setSuggestions((data.results || []).map(normalizeNPIResult));
      if (suggestionListRef.current) suggestionListRef.current.scrollTop = 0;
    } catch (error) {
      setSuggestions([]);
    } finally {
      setIsLoading(false);
    }
  };
 

  const highlightMatch = (name, query) => {
    const lastWord = query.trim().split(' ').pop();
    // Escape special regex characters to prevent regex errors
    const escapedQuery = lastWord.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapedQuery})`, 'gi');
    const parts = name.split(regex);
    return parts.map((part, index) => (
      part.toLowerCase() === query.trim().split(' ').pop().toLowerCase() ? (
        <span key={index} style={{ textDecoration: 'underline' }}>
          {part}
        </span>
      ) : (
        part
      )
    ));
  };
   
  const getToken = async () => {
    const response = await fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/getAssemblyAIToken');
    const data = await response.json();
    if (data.error) {
      return null;
    }
    return data.token;
  };

  const generateTranscript = async (targetTextArea) => {
    try {
      const token = await getToken();
      if (!token) return;
      setIsConnecting(true);
      socket.current = new WebSocket(`wss://api.assemblyai.com/v2/realtime/ws?sample_rate=16000&token=${token}`);

      const texts = {};
      socket.current.onmessage = (voicePrompt) => {
       // let msg = '';
        let msg = transcripts[targetTextArea] || ''; 
        const res = JSON.parse(voicePrompt.data);
        if (res.text && res.text.trim() !== '') {  // Check if res.text is not null or blank
          texts[res.audio_start] = res.text;
        }
        // texts[res.audio_start] = res.text;
        const keys = Object.keys(texts).filter(key => key !== 'undefined').sort((a, b) => a - b);
        keys.forEach((key) => {
          msg += ` ${texts[key]}`;
        });

        setTranscripts((prevState) => ({
          ...prevState,
          [targetTextArea]: msg.trim(), // || '',
        }));
      };

      socket.current.onerror = (event) => {
       // logger.error('WebSocket error:', event);
        socket.current.close();
        socket.current = null;
        setIsConnecting(false);
      };

      socket.current.onclose = (event) => { 
        socket.current = null;
        setIsConnecting(false);
      };

      socket.current.onopen = () => {
        setIsConnecting(false);
        navigator.mediaDevices.getUserMedia({ audio: true })
          .then((stream) => {
            streamRef.current = stream;
            recorder.current = new RecordRTC(stream, {
              type: 'audio',
              mimeType: 'audio/webm;codecs=pcm',
              recorderType: RecordRTC.StereoAudioRecorder,
              timeSlice: 250,
              desiredSampRate: 16000,
              numberOfAudioChannels: 1,
              bufferSize: 4096,
              audioBitsPerSecond: 128000,
              ondataavailable: (blob) => {
                const reader = new FileReader();
                reader.onload = () => {
                  const base64data = reader.result;
                  if (socket.current) {
                    socket.current.send(JSON.stringify({ audio_data: base64data.split('base64,')[1] }));
                  }
                };
                reader.readAsDataURL(blob);
              },
            });
            recorder.current.startRecording();
          })
          .catch((err) => logger.error('getUserMedia error:', err));
      };

      setIsRecording((prevState) => ({
        ...prevState,
        [targetTextArea]: true,
      }));

      setActiveMic(targetTextArea);
    } catch (error) {
      logger.error('Error generating transcript:', error);
    }
  };

  const endTranscription = (targetTextArea) => {
    if (socket.current) {
      socket.current.send(JSON.stringify({ terminate_session: true }));
      socket.current.close();
      socket.current = null;
    }

    if (recorder.current) {
      recorder.current.stopRecording();
      recorder.current = null;
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }

    setIsRecording((prevState) => ({
      ...prevState,
      [targetTextArea]: false,
    }));

    setActiveMic(null);
  };

  const handleMicClick = (targetTextArea) => {
    if (isConnecting) { 
     // console.log('Connecting, please wait...');
      return;
    }
    if (activeMic === targetTextArea) {
      endTranscription(targetTextArea);
    } else {
      if (activeMic) {
        endTranscription(activeMic);
      }
      generateTranscript(targetTextArea);
    }
  };

  const resetTranscription = (targetTextArea) => {
    setTranscripts((prevState) => ({
      ...prevState,
      [targetTextArea]: '',
    }));

    setIsRecording((prevState) => ({
      ...prevState,
      [targetTextArea]: false,
    }));

    if (recorder.current) {
      recorder.current.stopRecording();
      recorder.current = null;
    }
    if (socket.current) {
      socket.current.close();
      socket.current = null;
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }

    setActiveMic(null);
  };

  const handleTextChange = (e, field) => {
    setTranscripts({ ...transcripts, [field]: e.target.value });
  };

  // Persist PageTwo form data to localStorage
  useEffect(() => {
    const dataToSave = {
      transcripts,
      medicationRows: medicationRows.map(r => ({ name: r.name, dose: r.dose, frequency: r.frequency, searchText: r.searchText })),
    };
    localStorage.setItem('pageTwoData', JSON.stringify(dataToSave));
  }, [transcripts, medicationRows]);

  useEffect(() => {
    return () => {
      if (recorder.current) {
        recorder.current.stopRecording(() => {
          recorder.current = null;
        });
      }
      if (socket.current) {
        socket.current.close();
        socket.current = null;
      }
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
        streamRef.current = null;
      }
    };
  }, []);
  const handleSuggestionClickAllergies1 = (name) => {
    const words = transcripts.allergies.trim().split(' ');
    words.pop();
    if (!words.includes(name)) {
      const formattedText = words.length > 0 ? words.join(' ') + ', ' + name + ' ' : name;
      setTranscripts({ ...transcripts, allergies: formattedText });
      setAllergiesSuggestions([]);
      if (inputRefeAllergiestxt.current) {
        inputRefeAllergiestxt.current.focus();
      }
    } else {
      setAllergiesSuggestions([]);
    }
    window.scrollTo(0, 0);
  };
  const handleTextChangeAllergies1 = (e) => {
    setTranscripts({ ...transcripts, allergies: e.target.value });
    const AllergiesTxt =  e.target.value;
    setAllergiesData(AllergiesTxt);
    const lastWord = AllergiesTxt.trim().split(' ').pop();
    const lastChar = AllergiesTxt.slice(-1);
    if (!isConnecting && lastWord.length >= 3 && lastWord.trim() !== '' && lastChar !== ' ') {
      fetchSuggestions(lastWord, setAllergiesSuggestions, 'medicine');
    } else {
      setAllergiesSuggestions([]);
    }
  };
  // --- Medication row handlers ---
  const updateMedRow = (index, updates) => {
    setMedicationRows(prev => {
      const rows = [...prev];
      rows[index] = { ...rows[index], ...updates };
      return rows;
    });
  };
  const handleMedRowSearch = (index, value) => {
    updateMedRow(index, { searchText: value });
    if (!isConnecting && value.trim().length >= 3) {
      // Fetch suggestions for this specific row
      setIsLoading(true);
      axios.get(
        `https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search?terms=${encodeURIComponent(value.trim())}&ef=STRENGTHS_AND_FORMS`
      ).then(response => {
        const names = response.data[1] || [];
        const strengthsData = response.data[2]?.STRENGTHS_AND_FORMS || [];
        const strengthsMap = {};
        names.forEach((name, idx) => {
          strengthsMap[name] = strengthsData[idx] || [];
        });
        setMedicationStrengthsMap(prev => ({ ...prev, ...strengthsMap }));
        updateMedRow(index, { suggestions: names.slice(0, 15) });
      }).catch(() => {
        updateMedRow(index, { suggestions: [] });
      }).finally(() => setIsLoading(false));
    } else {
      updateMedRow(index, { suggestions: [] });
    }
  };
  const handleMedRowSelect = (index, name) => {
    const doses = medicationStrengthsMap[name] || [];
    updateMedRow(index, { name, searchText: name, suggestions: [], doseOptions: doses });
  };
  const handleMedRowDoseChange = (index, dose) => {
    updateMedRow(index, { dose });
  };
  const handleMedRowFrequencyChange = (index, frequency) => {
    updateMedRow(index, { frequency });
  };
  const handleAddMedRow = () => {
    setMedicationRows(prev => [...prev, { name: '', dose: '', frequency: '', searchText: '', suggestions: [], doseOptions: [] }]);
  };
  const handleRemoveMedRow = (index) => {
    setMedicationRows(prev => {
      const rows = prev.filter((_, i) => i !== index);
      if (rows.length === 0) return [{ name: '', dose: '', frequency: '', searchText: '', suggestions: [], doseOptions: [] }];
      return rows;
    });
  };
  // Sync medication rows to transcripts.medications for form submission
  const syncMedicationRows = (rows) => {
    const filled = rows.filter(r => r.name);
    const text = filled.map(m => {
      let entry = m.name;
      if (m.dose) entry += ` (${m.dose})`;
      if (m.frequency) entry += ` - ${m.frequency}`;
      return entry;
    }).join(', ');
    setTranscripts(prev => ({ ...prev, medications: text }));
    setMedicationsData(text);
  };
  // Keep transcripts in sync whenever rows change
  const prevMedRowsRef = useRef(medicationRows);
  if (prevMedRowsRef.current !== medicationRows) {
    prevMedRowsRef.current = medicationRows;
    syncMedicationRows(medicationRows);
  }

  const handleSpeechRecognition = (field) => {
    if (listening && activeSpeech === field) {
      SpeechRecognition.stopListening();
      setActiveSpeech(null);
    } else {
      setActiveSpeech(field);
      resetTranscript();
      SpeechRecognition.startListening({ continuous: true });
    }
  };

  useEffect(() => {
    if (activeSpeech) {
      setTranscripts((prev) => ({ ...prev, [activeSpeech]: transcript }));
    }
  }, [transcript, activeSpeech]);

 
    const checkBMICal = async () => {
      try {
        const userId = JSON.parse(localStorage.getItem('UserId'));
        const user = await getUser(userId);
        setShowBMICal(user?.bmi || 'N/A');
      } catch (error) {
        logger.error('Error fetching BMI:', error);
        setShowBMICal('N/A');
      } finally {
        setTxtLoader(false);
      }
    };
  useEffect(() => {
    setTxtLoader(true)
    checkBMICal()
    const items = JSON.parse(localStorage.getItem('UserId'));
    // Only generate a new reportId if one doesn't already exist
    const existingReportId = JSON.parse(localStorage.getItem('reportId') || '""');
    if (!existingReportId) {
      generateUniqueId(items);
    }
    if (items) {
      setUserId(items);
    }
  }, []);
    

  const handleFilesChange = (event) => {
    const files = Array.from(event.target.files).slice(0, 5); // Accept up to 5 files
    // setUploadFiles(files);
    setUploadFiles(prevFiles => [...prevFiles, ...files]); // Append new files to the existing ones
    fileInputRefReport1.current.value = ''; 
  };
  const triggerFileUploadFiles = () => {
    fileInputRefReport1.current.click();
  };
  const handleDeleteFile = (index) => {
    const updatedFiles = [...uploadFiles];
    updatedFiles.splice(index, 1);
    setUploadFiles(updatedFiles);
    
  };
   
 
  // Handler to update the selected option state
  const handleOptionChangeSmoke = (event) => {
    setSelectedSmoking(event.target.value);
  };
  const handleOptionChangeAlcohol = (event) => {
    setSelectedAlcohol(event.target.value);
  };
  const handleOptionChangeExercise = (event) => {
    setSelectedExercise(event.target.value);
  };

  // Options array
  const SmokeOptions = [
    { value: 'Current Smoker', label: 'Current Smoker' },
    { value: 'Frequent Smoker', label: 'Frequent Smoker' },
    { value: 'Former Smoker', label: 'Former Smoker' },
    { value: 'Never', label: 'Never' },
  ];
  // Options array
  const AlcoholOptions = [
    { value: 'Occasional', label: 'Occasional' },
    { value: 'Frequent', label: 'Frequent' },
    { value: 'Never', label: 'Never' },
  ];
  // Options array
  const ExerciseOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
  ];

  const handleTextChangeMedications = (event) => {
    setMedicationsData(event.target.value);
  };
  const handleFileChangeMedications = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setMedicationsFile(selectedFile);
      setFileNameMedications(selectedFile.name);
    } else {
      alert('Please select a PDF file.');
    }
  }; 
  const handleDeleteFileMedications = () => {
    setMedicationsFile(null);
    setFileNameMedications('');
    fileInputRefMedications.current.value = '';
  };
  const triggerFileInputMedications = () => {
    fileInputRefMedications.current.click();
  };
 
  
  const handleSuggestionClickMedicalCondition = (name) => { 
    const words = transcripts.medicalcondition.trim().split(' ');
    words.pop();
    // words.push(name);   
  // Check if the word is already present
if (!words.includes(name)) {
  // If there are existing words, add a comma before the new word
  const formattedText = words.length > 0 ? words.join(' ') + ', ' + name + ' ' : name;

  // Update the state with the formatted text
  setTranscripts({ ...transcripts, medicalcondition: formattedText });
  setMedicalConditionSuggestions([]);
  if (inputRefeMedicalConditionTxt.current) {
    inputRefeMedicalConditionTxt.current.focus();
  } 
} else {
  // If the word is already present, reset the suggestions
  setMedicalConditionSuggestions([]);
}
    // setTranscripts({ ...transcripts, medicalcondition: formattedText }); 
    // setTranscripts({ ...transcripts, medicalcondition: words.join(' ') + ' '}); 
    // setMedicalConditionSuggestions([]);
    window.scrollTo(0, 0);
  }; 
  const handleTextChangeMedicalCondition = (e) => {   
    setTranscripts({ ...transcripts, medicalcondition: e.target.value });     
    const valueTxt =  e.target.value;
    setMedicalConditionsData(valueTxt); 
    const lastWord = valueTxt.trim().split(' ').pop();
    const lastChar = valueTxt.slice(-1);
    if (!isConnecting && lastWord.length >= 3 && lastWord.trim() !== '' && lastChar !== ' ') {
      fetchSuggestionsMedicalCondition(lastWord, setMedicalConditionSuggestions);
    } else {
      setMedicalConditionSuggestions([]);
    }
    
  };
  const handleFileChangeMedicalCondition = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setMedicalConditionFile(selectedFile);
      setFileNameMedicalCondition(selectedFile.name);
    } else {
      alert('Please select a PDF file.');
    }
  };

  const handleDeleteFileMedicalCondition = () => {
    setMedicalConditionFile(null);
    setFileNameMedicalCondition('');
    fileInputRefMediConditions.current.value = '';
  };
  const triggerFileInputMedicalCondition = () => {
    fileInputRefMediConditions.current.click();
  };

  const handleTextChangePCP = (e) => {
    setTranscripts({ ...transcripts, pcp: e.target.value, pcpPhone: '', pcpFax: '', pcpName: '', pcpAddress: '' });
    const valueTxt =  e.target.value;
    setPCPData(valueTxt);
    const lastWord = valueTxt.trim();
    const lastChar = valueTxt.slice(-1);
    if (!isConnecting && lastWord.length >= 3 && lastWord.trim() !== '' && lastChar !== ' ') {
      fetchNPISuggestionsProvider(lastWord, setPCPSuggestions);
    } else {
      setPCPSuggestions([]);
    }
  };

  const handleSuggestionClickPCP = (name) => {
    const nameText = name.displayName.text;
    const addressText = name.formattedAddress;
    const valueTxt = nameText + (addressText ? ', ' + addressText : '');
    // Phone & fax come directly from the NPI result — no second API call needed
    const phone = name._npi?.practiceAddress?.phone || '';
    const fax = name._npi?.practiceAddress?.fax || '';

    setTranscripts(prev => ({
      ...prev,
      pcpName: nameText,
      pcpAddress: addressText,
      pcpPhone: phone,
      pcpFax: fax,
      pcp: valueTxt,
    }));
    setErrors(prev => ({ ...prev, pcpPhone: '', pcpFax: '' }));
    if (textareaRefPCP.current) textareaRefPCP.current.focus();
    window.scrollTo(0, 0);
    setPCPSuggestions([]);
  }; 

  
  const handleTextChangePharmacy = (e) => {
    setTranscripts({ ...transcripts, pharmacy: e.target.value, pharmacyPhone: '', pharmacyFax: '', pharmacyName: '', pharmacyAddress: '' });
    const valueTxt =  e.target.value;
    setPharmacyData(valueTxt);
    const lastWord = valueTxt.trim();
    const lastChar = valueTxt.slice(-1);
    if (!isConnecting && lastWord.length >= 3 && lastWord.trim() !== '' && lastChar !== ' ') {
      fetchNPISuggestionsOrg(lastWord, setPharmacySuggestions);
    } else {
      setPharmacySuggestions([]);
    }
  };

  const handleSuggestionClickPharmacy = (name) => {
    const nameText = name.displayName.text;
    const addressText = name.formattedAddress;
    const valueTxt1 = nameText + (addressText ? ', ' + addressText : '');
    // Phone & fax come directly from the NPI result — no second API call needed
    const phone = name._npi?.practiceAddress?.phone || '';
    const fax = name._npi?.practiceAddress?.fax || '';

    setTranscripts(prev => ({
      ...prev,
      pharmacyName: nameText,
      pharmacyAddress: addressText,
      pharmacyPhone: phone,
      pharmacyFax: fax,
      pharmacy: valueTxt1,
    }));
    setErrors(prev => ({ ...prev, pharmacyPhone: '', pharmacyFax: '' }));
    if (textareaRefPharmacy.current) textareaRefPharmacy.current.focus();
    window.scrollTo(0, 0);
    setPharmacySuggestions([]);
  }; 
 
  const handleTextChangeSocialHistory = (e) => {
    setTranscripts({ ...transcripts, socialhistory: e.target.value });
    const valueTxt = e.target.value;
    setSocialHistoryData(valueTxt);
    const lastWord = valueTxt.trim().split(' ').pop();
    const lastChar = valueTxt.slice(-1);
    if (!isConnecting && lastWord.length >= 3 && lastWord.trim() !== '' && lastChar !== ' ') {
      fetchSuggestions(lastWord, setSocialHistorySuggestions, 'social');
    } else {
      setSocialHistorySuggestions([]);
    }
  };

  const handleSuggestionClickSocialHistory = (name) => {
    const words = transcripts.socialhistory.trim().split(' ');
    words.pop();
    if (!words.includes(name)) {
      const formattedText = words.length > 0 ? words.join(' ') + ', ' + name + ' ' : name;
      setTranscripts({ ...transcripts, socialhistory: formattedText });
      setSocialHistoryData(formattedText);
    }
    setSocialHistorySuggestions([]);
  };
  const handleFileChangeSocialHistory = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setSocialHistoryFile(selectedFile);
      setFileNameSocialHistory(selectedFile.name);
    } else {
      alert('Please select a PDF file.');
    }
  };
   
  const handleDeleteFileSocialHistory = () => {
    setSocialHistoryFile(null);
    setFileNameSocialHistory('');
    fileInputRefSocialHistory.current.value = '';
  };
  const triggerFileInputSocialHistory = () => {
    fileInputRefSocialHistory.current.click();
  };

  const handleSuggestionClickPSHistory = (name) => { 
    const words = transcripts.pshistory.trim().split(' ');
    words.pop();
    // words.push(name); 
    // setTranscripts({ ...transcripts, pshistory: words.join(' ') + ' '}); 
    // setPastSurgicalSuggestions([]);
      // Check if the word is already present
      if (!words.includes(name)) {
        // If there are existing words, add a comma before the new word
        const formattedText = words.length > 0 ? words.join(' ') + ', ' + name + ' ' : name;
      
        // Update the state with the formatted text
        setTranscripts({ ...transcripts, pshistory: formattedText });
        setPastSurgicalSuggestions([]);
        if (inputRefePShistorytxt.current) {
          inputRefePShistorytxt.current.focus();
        } 
      } else {
        // If the word is already present, reset the suggestions
        setPastSurgicalSuggestions([]);
      }
   
    window.scrollTo(0, 0);
  };
 

  const handleTextChangePSHistory = (e) => {
    setTranscripts({ ...transcripts, pshistory: e.target.value });     
    const valueTxt =  e.target.value;
    setPastSurgicalHistoryData(valueTxt);   
    const lastWord = valueTxt.trim().split(' ').pop();
    const lastChar = valueTxt.slice(-1);
    if (!isConnecting && lastWord.length >= 3 && lastWord.trim() !== '' && lastChar !== ' ') {
      fetchSuggestionsPastSurgical(lastWord, setPastSurgicalSuggestions);
    } else {
      setPastSurgicalSuggestions([]);
    }
  };
  const handleFileChangePSHistory = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setPSHistoryFile(selectedFile);
      setFileNamePSHistory(selectedFile.name);
    } else {
      alert('Please select a PDF file.');
    }
  };
 
  const handleDeleteFilePSHistory = () => {
    setPSHistoryFile(null);
    setFileNamePSHistory('');
    fileInputRefPSHistory.current.value = '';
    
  };
  const triggerFileInputPSHistory = () => {
    fileInputRefPSHistory.current.click();
  };
 

  const handleTextChangePhysicalExam = (e) => {
    setTranscripts({ ...transcripts, physicalexam: e.target.value });     
    const valueTxt =  e.target.value;
    setPhysicalExamData(valueTxt);   
  };
  const handleFileChangePhysicalExam = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setPhysicalExamFile(selectedFile);
      setFileNamePhysicalExam(selectedFile.name);
    } else {
      alert('Please select a PDF file.');
    }
  }; 
  const handleDeleteFilePhysicalExam = () => {
    setPhysicalExamFile(null);
    setFileNamePhysicalExam('');
    fileInputRefPhysicalExam.current.value = '';
  };
  const triggerFileInputPhysicalExam = () => {
    fileInputRefPhysicalExam.current.click();
  };

 
 
  const handleFileChangeAllergie = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setAllergiesFile(selectedFile);
      setFileNameAllergies(selectedFile.name);
    } else {
      alert('Please select a PDF file.');
    }
  };
   
  const handleDeleteFileAllergie = () => {
    setAllergiesFile(null);
    setFileNameAllergies('');
    fileInputRef.current.value = '';
  };
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
 
  const isValidPhone = (value) => {
    if (!value || value.trim() === '') return true; // optional
    const cleaned = value.replace(/[\s\-().+]/g, '');
    return /^\d{7,15}$/.test(cleaned);
  };

  const handleSubmitForm = async (event) => {
    event.preventDefault();

    // Phone / Fax validation
    const newErrors = {};
    if (!isValidPhone(transcripts.pcpPhone)) {
      newErrors.pcpPhone = 'Enter a valid PCP phone number (7–15 digits).';
    }
    if (!isValidPhone(transcripts.pcpFax)) {
      newErrors.pcpFax = 'Enter a valid PCP fax number (7–15 digits).';
    }
    if (!isValidPhone(transcripts.pharmacyPhone)) {
      newErrors.pharmacyPhone = 'Enter a valid Pharmacy phone number (7–15 digits).';
    }
    if (!isValidPhone(transcripts.pharmacyFax)) {
      newErrors.pharmacyFax = 'Enter a valid Pharmacy fax number (7–15 digits).';
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors({});
    setShowLoader(true);

    const UserId = JSON.parse(localStorage.getItem('UserId'));

    const formAllergy = new FormData();
    formAllergy.append('user_id', UserId);
    if (AllergiesFile) formAllergy.append('file', AllergiesFile);
    if (transcripts.allergies) formAllergy.append('text', transcripts.allergies);
    if (reportId) formAllergy.append('reports_id', reportId);
     

    // const formPhysicalExam = new FormData();
    // formPhysicalExam.append('user_id', UserId);
    // if (PhysicalExamFile) formPhysicalExam.append('file', PhysicalExamFile);
    // if (transcripts.physicalexam) formPhysicalExam.append('text', transcripts.physicalexam);
    // if (reportId) formPhysicalExam.append('reports_id', reportId);


    const formAPSHistory = new FormData();
    formAPSHistory.append('user_id', UserId);
    if (PSHistoryFile) formAPSHistory.append('file', PSHistoryFile);
    if (transcripts.pshistory) formAPSHistory.append('text', transcripts.pshistory);
    if (reportId) formAPSHistory.append('reports_id', reportId);


    const formMedicalCondition = new FormData();
    formMedicalCondition.append('user_id', UserId);
    if (MedicalConditionFile) formMedicalCondition.append('file', MedicalConditionFile);
    if (transcripts.medicalcondition) formMedicalCondition.append('text', transcripts.medicalcondition);
    if (reportId) formMedicalCondition.append('reports_id', reportId);


    const formMedications = new FormData();
    formMedications.append('user_id', UserId);
    if (MedicationsFile) formMedications.append('file', MedicationsFile);
    if (transcripts.medications) formMedications.append('text', transcripts.medications);
    if (reportId) formMedications.append('reports_id', reportId);

    const formSocialHistory = new FormData();
    formSocialHistory.append('user_id', UserId);
    if (SocialHistoryFile) formSocialHistory.append('file', SocialHistoryFile);
    if (transcripts.socialhistory) formSocialHistory.append('text', transcripts.socialhistory);
    if (reportId) formSocialHistory.append('reports_id', reportId);
 
    const formPCPData = new FormData();
    formPCPData.append('user_id', UserId); 
    if (transcripts.pcp) formPCPData.append('text', transcripts.pcp);
    if (reportId) formPCPData.append('reports_id', reportId);
 

    const formUploadFiles = new FormData();
    formUploadFiles.append('user_id', UserId); 
    if (reportId) formUploadFiles.append('reports_id', reportId);
    if (uploadFiles.length != 0) {
    uploadFiles.forEach((file, index) => {
      formUploadFiles.append(`file`, file);
    }); 
  }
 
    const apiCalls = [];
    const addReportDoc = (docType, textValue, fileValue) => {
      if (!textValue && !fileValue) return;
      apiCalls.push((async () => {
        const summaryText = (textValue || fileValue?.name || '').toString().trim();
        let uploadedFileUrl = '';

        if (fileValue) {
          const safeFileName = `${Date.now()}_${fileValue.name}`.replace(/\s+/g, '_');
          const fileRef = ref(storage, `medical_reports/${UserId}/${reportId}/${safeFileName}`);
          await uploadBytes(fileRef, fileValue);
          uploadedFileUrl = await getDownloadURL(fileRef);
        }

        const reportData = {
          user_id: UserId,
          reports_id: reportId,
          doc_type: docType,
          doc_summary: summaryText || docType,
          doc_text: (textValue || '').toString().trim(),
          file_name: fileValue?.name || '',
          doc_url: uploadedFileUrl || null,
          file_url: uploadedFileUrl || null
        };

        // FHIR: Save appropriate resource based on doc_type (fire-and-forget)
        saveFHIRFromMedicalReport(reportData, UserId);

        return createMedicalReport(reportData);
      })());
    };

    addReportDoc('allergy', transcripts.allergies, AllergiesFile);
    addReportDoc('medications', transcripts.medications, MedicationsFile);
    addReportDoc('medical_conditions', transcripts.medicalcondition, MedicalConditionFile);
    addReportDoc('past_surgical_history', transcripts.pshistory, PSHistoryFile);
    addReportDoc('social_history', transcripts.socialhistory, SocialHistoryFile);

    if (uploadFiles.length !== 0) {
      uploadFiles.forEach((file) => {
        addReportDoc('other_report', '', file);
      });
    }
    const payload_PCP_Pharmacy = {
      user_id: UserId,
      pcp: {
        name: transcripts.pcpName,
        phone: transcripts.pcpPhone || "",
        fax: transcripts.pcpFax || "",
        address: transcripts.pcpAddress,
        email: "",
      },
      pharmacy: {
        name: transcripts.pharmacyName,
        phone: transcripts.pharmacyPhone || "",
        fax: transcripts.pharmacyFax || "",
        address: transcripts.pharmacyAddress,
        email: "",
      },
    };
    if (transcripts.pcp || transcripts.pharmacy || transcripts.pcpName || transcripts.pcpAddress || transcripts.pharmacyName || transcripts.pharmacyAddress) {
      apiCalls.push(
        upsertPCPPharmacyDetails(reportId, payload_PCP_Pharmacy)
      );

      // FHIR: Save Practitioner (PCP) resource (fire-and-forget)
      if (payload_PCP_Pharmacy.pcp && payload_PCP_Pharmacy.pcp.name) {
        saveFHIRPractitioner({
          pcp_name: payload_PCP_Pharmacy.pcp.name,
          pcp_phone: payload_PCP_Pharmacy.pcp.phone,
          pcp_fax: payload_PCP_Pharmacy.pcp.fax,
          pcp_address: payload_PCP_Pharmacy.pcp.address,
          pcp_email: payload_PCP_Pharmacy.pcp.email,
        }, UserId);
      }
    }

    try {
      const responses = await Promise.all(apiCalls); 

      const allResponsesSuccessful = responses.length > 0;
      if(responses.length > 0 ){
            if (allResponsesSuccessful) { 
              setApiCallCount(prevCount => prevCount + responses.length); 
              toast.success('Information uploaded successfully!', {
                position: toast.POSITION.TOP_RIGHT,
               });
              routeChange()
              // Handle successful responses as needed
            } else {  
              toast.error('Information upload failed!', {
                position: toast.POSITION.TOP_RIGHT,
               });
              // Handle failed responses as needed
            } 
        }else{
          routeChange();
        }
    } catch (error) { 
      alert('Error during API calls');
      // Handle the error as needed
    } finally {
      setShowLoader(false);
    }
  };

  // Function to handle scrolling to the top of the textarea
  const handleScrollUp = (ref) => {
    if (ref.current) { 
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); 
    }
  };
 
  return (

    <main
      className="pt5 black-80 center stepFirstForm"
      style={{ maxWidth: "50%", margin: "20px auto" }}
    >
      

      <form onSubmit={handleSubmitForm} className="measure w-100 ">
        <h2>Please fill the details</h2>
        
        <fieldset id="sign_up" className="ba b--transparent ph0 mh0 fillDetailsMainForm">
          <div className={"mt3 inputDiv fillDetailsForm " + (TxtLoader ? '' : 'disabledTxtField')}>
            <label>BMI</label>
            {TxtLoader ? (<>
              <div class="spinnerTxt">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div></>) : (
              <input type="text" value={ShowBMICal} readOnly />
            )}

          </div>
        
          <div className="mt3 inputDiv fillDetailsForm newFillDetailForm"
           onClick={() => handleScrollUp(textareaRefAllergies)}
           ref={textareaRefAllergies}
           >
            <label>Allergies</label>
            <textarea ref={inputRefeAllergiestxt} value={transcripts.allergies} onChange={handleTextChangeAllergies1} placeholder={activeMic === 'allergies' ? 'Mic On ' : ""}></textarea>
            <span className="attachmentSpan">
              <label style={{ display: 'none' }} htmlFor="file">Upload PDF:</label>
              <input
                type="file"
                id="file"
                accept="application/pdf"
                onChange={handleFileChangeAllergie}
                style={{ display: 'none' }}
                ref={fileInputRef}
              />
              <a onClick={triggerFileInput}  >
                <img src={Icons[0].attachIcon} className="logoImg " alt="" />
              </a>
            </span>
            {fileNameAllergies && (
              <div className='attachmentListData'>
                <p>{fileNameAllergies}</p>
                <button type="button" onClick={handleDeleteFileAllergie} className='attachmentDeleteBtn'>
                  <img src={Icons[0].deleteIcon} className="logoImg " alt="" />
                </button>
              </div>
            )}
             <ul ref={suggestionListRef} className={'suggestionMedicineList ' + (allergiesSuggestions.length > 0 ? '' : 'd-none' )}>
                {allergiesSuggestions.map((name, index) => (
                  <li key={index} onClick={() => handleSuggestionClickAllergies1(name)}>
                    {highlightMatch(name , transcripts.allergies)}
                  </li>
                ))}
              </ul>
          </div>
          {errors.AllergiesData && <span  className="errorTxt" >{errors.AllergiesData}</span>}
 
          <div className="mt3 inputDiv fillDetailsForm newFillDetailForm" ref={textareaRefMedications}>
            <label>Medications</label>
            <span className="attachmentSpan">
              <label style={{ display: 'none' }} htmlFor="file">Upload PDF:</label>
              <input
                type="file"
                id="file"
                accept="application/pdf"
                onChange={handleFileChangeMedications}
                style={{ display: 'none' }}
                ref={fileInputRefMedications}
              />
              <a onClick={triggerFileInputMedications}>
                <img src={Icons[0].attachIcon} className="logoImg " alt="" />
              </a>
            </span>
            {fileNameMedications && (
              <div className='attachmentListData'>
                <p>{fileNameMedications}</p>
                <button type="button" onClick={handleDeleteFileMedications} className='attachmentDeleteBtn'>
                  <img src={Icons[0].deleteIcon} className="logoImg " alt="" />
                </button>
              </div>
            )}

            {/* Medication rows */}
            <div className="medRowsContainer">
              {medicationRows.map((row, index) => (
                <div key={index} className="medRow">
                  <div className="medRowFields">
                    {/* Medication search / selected name */}
                    <div className="medRowDrugField">
                      <input
                        type="text"
                        value={row.name || row.searchText}
                        onChange={(e) => {
                          if (row.name) {
                            updateMedRow(index, { name: '', doseOptions: [], dose: '', frequency: '' });
                          }
                          handleMedRowSearch(index, e.target.value);
                        }}
                        placeholder="Search medication..."
                        className="medRowInput"
                        autoComplete="off"
                      />
                      {row.suggestions.length > 0 && (
                        <ul className="suggestionMedicineList medRowSuggestions">
                          {row.suggestions.map((name, sIdx) => (
                            <li key={sIdx} onClick={() => handleMedRowSelect(index, name)}>
                              {highlightMatch(name, row.searchText)}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>

                    {/* Dose dropdown — shown after medication is selected */}
                    {row.name && row.doseOptions.length > 0 && (
                      <div className="medRowDoseField">
                        <select
                          value={row.dose}
                          onChange={(e) => handleMedRowDoseChange(index, e.target.value)}
                          className="medRowDoseSelect"
                        >
                          <option value="">Dose</option>
                          {row.doseOptions.map((dose, dIdx) => (
                            <option key={dIdx} value={dose}>{dose}</option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* Dose text input if no options from API */}
                    {row.name && row.doseOptions.length === 0 && (
                      <div className="medRowDoseField">
                        <input
                          type="text"
                          value={row.dose}
                          onChange={(e) => handleMedRowDoseChange(index, e.target.value)}
                          placeholder="Dose"
                          className="medRowInput medRowDoseInput"
                        />
                      </div>
                    )}

                    {/* Frequency dropdown — shown after medication is selected */}
                    {row.name && (
                      <div className="medRowFreqField">
                        <select
                          value={row.frequency}
                          onChange={(e) => handleMedRowFrequencyChange(index, e.target.value)}
                          className="medRowDoseSelect"
                        >
                          <option value="">Frequency</option>
                          <option value="Once daily">Once daily</option>
                          <option value="Twice daily">Twice daily</option>
                          <option value="3 times a day">3 times a day</option>
                          <option value="4 times a day">4 times a day</option>
                          <option value="Every morning">Every morning</option>
                          <option value="Every night">Every night</option>
                          <option value="Every 4 hours">Every 4 hours</option>
                          <option value="Every 6 hours">Every 6 hours</option>
                          <option value="Every 8 hours">Every 8 hours</option>
                          <option value="Every 12 hours">Every 12 hours</option>
                          <option value="As needed">As needed</option>
                          <option value="Weekly">Weekly</option>
                        </select>
                      </div>
                    )}

                    {/* Remove row button */}
                    {medicationRows.length > 1 && (
                      <button type="button" className="medRowRemoveBtn" onClick={() => handleRemoveMedRow(index)}>&times;</button>
                    )}
                  </div>
                </div>
              ))}

              <button type="button" className="medRowAddBtn" onClick={handleAddMedRow}>
                <span className="medRowAddIcon">+</span> Add Medication
              </button>
            </div>
          </div>
          {errors.MedicationsData && <span className="errorTxt">{errors.MedicationsData}</span>}

       
          <div className="mt3 inputDiv fillDetailsForm newFillDetailForm"  ref={textareaRefMediConditions}
          onClick={() => handleScrollUp(textareaRefMediConditions)}>
            <label>Medical Conditions</label>
            <textarea  ref={inputRefeMedicalConditionTxt}  value={transcripts.medicalcondition} onChange={handleTextChangeMedicalCondition} placeholder={activeMic === 'medicalcondition' ? 'Mic On ' : ""} ></textarea>
            <span className="attachmentSpan">
              {/* <a onClick={() => handleMicClick('medicalcondition')}  disabled={isConnecting || activeMic === 'connecting'} className={ (activeMic === 'medicalcondition' ? 'deactiveBtnClass' : 'activeBtnClass')}> 
              <img src={Icons[0].micIcon}  className= "logoImg "   alt="" /></a> */}
              <label style={{ display: 'none' }} htmlFor="file">Upload PDF:</label>
              <input
                type="file"
                id="file" 
                accept="application/pdf"
                onChange={handleFileChangeMedicalCondition}
                style={{ display: 'none' }} // Hide the default file input
                ref={fileInputRefMediConditions}
              />
              <a onClick={triggerFileInputMedicalCondition}  >
                <img src={Icons[0].attachIcon} className="logoImg " alt="" />
              </a>
            </span>
            {fileNameMedicalCondition && (
              <div className='attachmentListData'>
                <p>{fileNameMedicalCondition}</p>
                <button type="button" onClick={handleDeleteFileMedicalCondition} className='attachmentDeleteBtn'>
                  <img src={Icons[0].deleteIcon} className="logoImg " alt="" />
                </button>
              </div>
            )}
         <ul ref={suggestionListRef} className={'suggestionMedicineList ' + (medicalConditionSuggestions.length > 0 ? '' : 'd-none' )}>
                {medicalConditionSuggestions.map((name, index) => (
                  <li key={index} onClick={() => handleSuggestionClickMedicalCondition(name)}> 
                    {highlightMatch(name , transcripts.allergies)}
                  </li>
                ))}
              </ul>
          </div>
          {errors.MedicalConditionsData && <span  className="errorTxt" >{errors.MedicalConditionsData}</span>}
 
          <div className="mt3 inputDiv fillDetailsForm newFillDetailForm"  ref={textareaRefPSHistory}
          onClick={() => handleScrollUp(textareaRefPSHistory)}>
            <label>Past Surgical History</label>
            <textarea  ref={inputRefePShistorytxt} value={transcripts.pshistory} onChange={handleTextChangePSHistory} placeholder={activeMic === 'pshistory' ? 'Mic On ' : ""} ></textarea>
            <span className="attachmentSpan">
              {/* <a  onClick={() => handleMicClick('pshistory')}  disabled={isConnecting || activeMic === 'connecting'} className={(activeMic === 'pshistory' ? 'deactiveBtnClass' : 'activeBtnClass')}  > 
              <img src={Icons[0].micIcon}  className="logoImg "  alt="" /></a> */}
              <label style={{ display: 'none' }} htmlFor="file">Upload PDF:</label>
              <input
                type="file"
                id="file"
                accept="application/pdf"
                onChange={handleFileChangePSHistory}
                style={{ display: 'none' }} // Hide the default file input
                ref={fileInputRefPSHistory}
              />
              <a onClick={triggerFileInputPSHistory}  >
                <img src={Icons[0].attachIcon} className="logoImg " alt="" />
              </a>
            </span>
            {fileNamePSHistory && (
              <div className='attachmentListData'>
                <p>{fileNamePSHistory}</p>
                <button type="button" onClick={handleDeleteFilePSHistory} className='attachmentDeleteBtn'>
                  <img src={Icons[0].deleteIcon} className="logoImg " alt="" />
                </button>
              </div>
            )}
               <ul ref={suggestionListRef} className={'suggestionMedicineList ' + (pastSurgicalSuggestions.length > 0 ? '' : 'd-none' )}>
                {pastSurgicalSuggestions.map((name, index) => (
                  <li key={index} onClick={() => handleSuggestionClickPSHistory(name)}> 
                    {highlightMatch(name , transcripts.allergies)}
                  </li>
                ))}
              </ul>
          </div>
          {errors.PastSurgicalHistoryData && <span  className="errorTxt" >{errors.PastSurgicalHistoryData}</span>}

          
          {/* <div className="mt3 inputDiv fillDetailsForm newFillDetailForm" ref={textareaRefPhysicalExam} 
          onClick={() => handleScrollUp(textareaRefPhysicalExam)}>
            <label>Physical Exam</label>
            <textarea  value={transcripts.physicalexam} onChange={handleTextChangePhysicalExam} placeholder={activeMic === 'physicalexam' ? 'Mic On ' : ""} ></textarea>
            <span className="attachmentSpan">
              <a onClick={() => handleMicClick('physicalexam')} disabled={isConnecting || activeMic === 'connecting'}  className={ (activeMic === 'physicalexam' ? 'deactiveBtnClass' : 'activeBtnClass')}  > 
              <img src={Icons[0].micIcon}  className= "logoImg "   alt="" /></a>
              <label style={{ display: 'none' }} htmlFor="file">Upload PDF:</label>
              <input
                type="file"
                id="file"
                accept="application/pdf"
                onChange={handleFileChangePhysicalExam}
                style={{ display: 'none' }} // Hide the default file input
                ref={fileInputRefPhysicalExam}
              />
              <a onClick={triggerFileInputPhysicalExam}  >
                <img src={Icons[0].attachIcon} className="logoImg " alt="" />
              </a>
            </span>
            {fileNamePhysicalExam && (
              <div className='attachmentListData'>
                <p>{fileNamePhysicalExam}</p>
                <button type="button" onClick={handleDeleteFilePhysicalExam} className='attachmentDeleteBtn'>
                  <img src={Icons[0].deleteIcon} className="logoImg " alt="" />
                </button>
              </div>
            )}
          </div>
          {errors.PhysicalExamData && <span  className="errorTxt" >{errors.PhysicalExamData}</span>} */}
          
          <div className="mt3 inputDiv fillDetailsForm newFillDetailForm"
          onClick={() => handleScrollUp(textareaRefSocialHistory)}>
            <label>Social History</label>
            <textarea  ref={textareaRefSocialHistory} value={transcripts.socialhistory} onChange={handleTextChangeSocialHistory} placeholder={activeMic === 'socialhistory' ? 'Mic On ' : ""}></textarea>
            <ul ref={suggestionListRef} className={'suggestionMedicineList ' + (socialHistorySuggestions.length > 0 ? '' : 'd-none')}>
              {socialHistorySuggestions.map((name, index) => (
                <li key={index} onClick={() => handleSuggestionClickSocialHistory(name)}>
                  {highlightMatch(name, transcripts.socialhistory)}
                </li>
              ))}
            </ul>
            <span className="attachmentSpan">
              {/* <a onClick={() => handleMicClick('socialhistory')} disabled={isConnecting || activeMic === 'connecting'}   className={ (activeMic === 'socialhistory' ? 'deactiveBtnClass' : 'activeBtnClass')} > 
              <img src={Icons[0].micIcon}  className= "logoImg " alt="" /></a> */}
              <label style={{ display: 'none' }} htmlFor="file">Upload PDF:</label>
              <input
                type="file"
                id="file"
                accept="application/pdf"
                onChange={handleFileChangeSocialHistory}
                style={{ display: 'none' }} // Hide the default file input
                ref={fileInputRefSocialHistory}
              />
              <a onClick={triggerFileInputSocialHistory}  >
                <img src={Icons[0].attachIcon} className="logoImg " alt="" />
              </a>
            </span>
            {fileNameSocialHistory && (
              <div className='attachmentListData'>
                <p>{fileNameSocialHistory}</p>
                <button type="button" onClick={handleDeleteFileSocialHistory} className='attachmentDeleteBtn'>
                  <img src={Icons[0].deleteIcon} className="logoImg " alt="" />
                </button>
              </div>
            )}
          </div>
          {errors.SocialHistoryData && <span  className="errorTxt" >{errors.SocialHistoryData}</span>}
        
             <div className='d-flex gap-3' ref={textareaRefPCP}>
             <div className="mt3 inputDiv fillDetailsForm newFillDetailForm">
          <div className="  fillDetailsForm newFillDetailForm"
          onClick={() => handleScrollUp(textareaRefPCP)}>
            <label>Primary Care Physician (PCP) <span title="Search by doctor or clinic name. Phone &amp; Fax will auto-fill from the NPI registry after selection." style={{cursor: 'pointer', display: 'inline-flex', verticalAlign: 'middle', marginLeft: '4px'}}><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7" stroke="#888" strokeWidth="1.5"/><text x="8" y="12" textAnchor="middle" fontSize="10" fontWeight="bold" fill="#888">i</text></svg></span></label>
            <textarea className='w-100'  ref={textareaRefPCP} value={transcripts.pcp}
           onChange={handleTextChangePCP} placeholder="Search doctor or clinic name"></textarea>
          </div>
          <ul ref={textareaRefPCP} className={'suggestionMedicineList w-100 ' + (pcpSuggestions.length > 0 ? '' : 'd-none' )}
              >
                {pcpSuggestions.map((name, index) => (
                  <li key={index} onClick={() => handleSuggestionClickPCP(name)}>
                    {highlightMatch(name.displayName.text , transcripts.pcp)}
                    <p>{name.formattedAddress}</p>
                  </li>
                ))}
              </ul>
             </div>

          <div className="mt3 inputDiv fillDetailsForm newFillDetailForm">
          <div className="  fillDetailsForm newFillDetailForm"
          onClick={() => handleScrollUp(textareaRefPharmacy)}>
            <label>Pharmacy information <span title="Search by pharmacy name. Phone &amp; Fax will auto-fill from the NPI registry after selection." style={{cursor: 'pointer', display: 'inline-flex', verticalAlign: 'middle', marginLeft: '4px'}}><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7" stroke="#888" strokeWidth="1.5"/><text x="8" y="12" textAnchor="middle" fontSize="10" fontWeight="bold" fill="#888">i</text></svg></span></label>
            <textarea className='w-100' ref={textareaRefPharmacy} value={transcripts.pharmacy}
            onChange={handleTextChangePharmacy} placeholder="Search pharmacy name"></textarea>
          </div>
          <ul ref={textareaRefPharmacy} className={'suggestionMedicineList w-100 ' + (pharmacySuggestions.length > 0 ? '' : 'd-none' )}
              >
                {pharmacySuggestions.map((name, index) => (
                  <li key={index} onClick={() => handleSuggestionClickPharmacy(name)}>
                    {highlightMatch(name.displayName.text , transcripts.pharmacy)}
                    <p>{name.formattedAddress}</p>
                  </li>
                ))}
              </ul>
             </div>
       </div>

       {/* PCP Phone & Fax — single card | Pharmacy Phone & Fax — single card */}
       <div className='d-flex gap-3 pcpPharmacyContactRow'>
         <div className="mt3 inputDiv fillDetailsForm newFillDetailForm pcpPharmacyContactCard">
           <label>PCP Phone &amp; Fax <span title="Auto-filled from the NPI registry when you select a PCP above. You can also edit manually." style={{cursor: 'pointer', display: 'inline-flex', verticalAlign: 'middle', marginLeft: '4px'}}><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7" stroke="#888" strokeWidth="1.5"/><text x="8" y="12" textAnchor="middle" fontSize="10" fontWeight="bold" fill="#888">i</text></svg></span></label>
           <div className="pcpPharmacyContactInputs">
             <div className="pcpPharmacyContactField">
               <span className="pcpPharmacySubLabel">Phone</span>
               <input
                 type="tel"
                 value={transcripts.pcpPhone}
                 onChange={(e) => { const v = e.target.value.replace(/[^\d+\-() ]/g, ''); setTranscripts({ ...transcripts, pcpPhone: v }); setErrors((prev) => ({ ...prev, pcpPhone: '' })); }}
                 className={errors.pcpPhone ? 'inputError' : ''}
               />
               {errors.pcpPhone && <span className="errorTxt">{errors.pcpPhone}</span>}
             </div>
             <div className="pcpPharmacyContactField">
               <span className="pcpPharmacySubLabel">Fax</span>
               <input
                 type="tel"
                 value={transcripts.pcpFax}
                 onChange={(e) => { const v = e.target.value.replace(/[^\d+\-() ]/g, ''); setTranscripts({ ...transcripts, pcpFax: v }); setErrors((prev) => ({ ...prev, pcpFax: '' })); }}
                 className={errors.pcpFax ? 'inputError' : ''}
               />
               {errors.pcpFax && <span className="errorTxt">{errors.pcpFax}</span>}
             </div>
           </div>
         </div>
         <div className="mt3 inputDiv fillDetailsForm newFillDetailForm pcpPharmacyContactCard">
           <label>Pharmacy Phone &amp; Fax <span title="Auto-filled from the NPI registry when you select a Pharmacy above. You can also edit manually." style={{cursor: 'pointer', display: 'inline-flex', verticalAlign: 'middle', marginLeft: '4px'}}><svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7" stroke="#888" strokeWidth="1.5"/><text x="8" y="12" textAnchor="middle" fontSize="10" fontWeight="bold" fill="#888">i</text></svg></span></label>
           <div className="pcpPharmacyContactInputs">
             <div className="pcpPharmacyContactField">
               <span className="pcpPharmacySubLabel">Phone</span>
               <input
                 type="tel"
                 value={transcripts.pharmacyPhone}
                 onChange={(e) => { const v = e.target.value.replace(/[^\d+\-() ]/g, ''); setTranscripts({ ...transcripts, pharmacyPhone: v }); setErrors((prev) => ({ ...prev, pharmacyPhone: '' })); }}
                 className={errors.pharmacyPhone ? 'inputError' : ''}
               />
               {errors.pharmacyPhone && <span className="errorTxt">{errors.pharmacyPhone}</span>}
             </div>
             <div className="pcpPharmacyContactField">
               <span className="pcpPharmacySubLabel">Fax</span>
               <input
                 type="tel"
                 value={transcripts.pharmacyFax}
                 onChange={(e) => { const v = e.target.value.replace(/[^\d+\-() ]/g, ''); setTranscripts({ ...transcripts, pharmacyFax: v }); setErrors((prev) => ({ ...prev, pharmacyFax: '' })); }}
                 className={errors.pharmacyFax ? 'inputError' : ''}
               />
               {errors.pharmacyFax && <span className="errorTxt">{errors.pharmacyFax}</span>}
             </div>
           </div>
         </div>
       </div>
          <div className="mt3 inputDiv fillDetailsForm newFillDetailForm uploadFilelistMain">
            <label>Upload Report (Max. file size 15 MB)</label>
            <span className="attachmentSpan">
               <label style={{ display: 'none' }} htmlFor="file">Upload PDF:</label>
              <input
                type="file"
                id="file"
                accept="application/pdf"
                multiple
                onChange={handleFilesChange}
                style={{ display: 'none' }} // Hide the default file input
                ref={fileInputRefReport1}
              />
              <a onClick={triggerFileUploadFiles}  >
                <img src={Icons[0].attachIcon} className="logoImg " alt="" />
              </a>
            </span>
            <div className='attachmentListData '>
            <table>
             {uploadFiles.map((file, index) => (
                <tr key={index} className='uploadFilelistOpt'  >
                  <td>{file.name}</td>
                  <td><button type="button" className='attachmentDeleteBtn' onClick={() => handleDeleteFile(index)}><img src={Icons[0].deleteIcon} className="logoImg " alt="" /></button></td>
                </tr>
              ))}
              </table>
          </div>
          </div>
        </fieldset>
        <div>
          {ShowLoader ? (<>
            <button className="signInBtn mb-0" > Loading
              <div className="spinner-border text-light  " role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </button>
          </>) : (<>
            <button className="signInBtn mb-0" type="submit" >Next</button>
          </>)}
 
    
        </div>
      </form>
    </main>
  );
}

export default PageTwo;
